export default __webpack_public_path__ + "d91903d3d5a67fb0cb2e35b78828a5a2.jpg";